import { merge } from 'lodash';

const defaultArgs = {
  first: 1,
  orderBy: 'timeStamp',
  orderDirection: 'desc'
};

const defaultAttrs = {
  circulateBal: true,
  timeStamp: true,
  ratioOflocked: true,
  lockedFlake: true
};

export default (attrs = {}) => ({
  flakeCirculates: {
    __args: merge({}, defaultArgs),
    ...merge({}, defaultAttrs, attrs)
  }
});
